import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Col, Row, Tab, Tabs } from "react-bootstrap";

import { useAppSelector } from "../../../Redux/hooks";

import Property from "./Property";
import SearchNav from "../SearchNav";
import TaxSummary from "./TaxSummary";
import Permits from "./Permits";
import Violations from "./Violations";
import CosDobNow from "./CosDobNow";
import CosBis from "./CosBis";
import { disclaimerSearch1 } from "../../Tos/Disclaimer";

export default function Results() {
  const property = useAppSelector((state) => state.property);
  const navigate = useNavigate();
  useEffect(() => {
    if (property.assessment === null || property.dobnow === null) {
      navigate("/property-search");
    }
  }, [property]);
  let safeToShowCoDobNow = true;
  if (property.dobnow === undefined) safeToShowCoDobNow = false;
  if (property.dobnow?.BIN === undefined || property.dobnow?.BIN === "")
    safeToShowCoDobNow = false;
  if (property.dobnow?.Borough === undefined) safeToShowCoDobNow = false;
  if (property.dobnow?.HouseNo === undefined || property.dobnow?.HouseNo === "")
    safeToShowCoDobNow = false;
  if (
    property.dobnow?.StreetName === undefined ||
    property.dobnow?.StreetName === ""
  )
    safeToShowCoDobNow = false;
  // console.log(property.dobnow);
  // console.log("safeToShowCoDobNow", safeToShowCoDobNow);
  return (
    <div className="results">
      <div>
        <SearchNav />
        <div className="result-content">
          <Row>
            <Col lg={3}>
              <Property />
            </Col>
            <Col lg={9}>
              <Tabs defaultActiveKey="tax">
                <Tab eventKey="tax" title="Taxes">
                  {property.assessment && (
                    <TaxSummary
                      boro={property.assessment.boro}
                      block={property.assessment.block}
                      lot={property.assessment.lot}
                      easement={property.assessment.easement}
                    />
                  )}
                </Tab>
                <Tab eventKey="permits" title="Permits">
                  {property.dobnow && <Permits bin={property.dobnow.BIN} />}
                </Tab>
                <Tab eventKey="violations" title="Violations">
                  {property.assessment && (
                    <Violations
                      boro={property.assessment.boro}
                      block={property.assessment.block}
                      lot={property.assessment.lot}
                    />
                  )}
                </Tab>
                <Tab eventKey="co" title="COs">
                  <div className="co-wrapper">
                    {safeToShowCoDobNow && (
                      <CosDobNow
                        boro={`${property.dobnow?.Borough}`}
                        houseNo={`${property.dobnow?.HouseNo}`}
                        streetName={`${property.dobnow?.StreetName}`}
                        bin={`${property.dobnow?.BIN}`}
                      />
                    )}
                    {property.dobnow && property.dobnow.BIN !== "" && (
                      <CosBis bin={property.dobnow.BIN} />
                    )}
                  </div>
                </Tab>
              </Tabs>{" "}
            </Col>
          </Row>
        </div>
      </div>
      <Row className="justify-content-center">
        <Col lg={9}>
          <div className="disclaimer">{disclaimerSearch1}</div>
        </Col>
      </Row>
    </div>
  );
}
